import InterpretationTypeEntity from '../entities/InterpretationType.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getInterpretationTypes(abortSignal: AbortSignal): Promise<Array<InterpretationTypeEntity>> {    
    return apiGet<Array<InterpretationTypeEntity>>('/interpretation-type',abortSignal);
}
